import React from 'react'
import { message } from '../components/Messages'
import { domains } from '../pages/domains'
import api, { auth } from './api'
import { useE, useEventListener, useR } from './hooks'
import { useSocket } from './socket'
import { JSX } from './types'
import url from './url'
import { socketRooms } from './socket-lifecycle'
import { decodeNotificationPacket } from './notification-packet'
import { showDeviceNotification } from './device-notifications'

const Notification = ('Notification' in window) ? window.Notification : undefined

export function twitter(handle?) {
  return api.post(`notify/twitter`, { handle })
}

export function sub(page) {
  console.debug(Notification?.permission
    || 'notifications not supported')
  if (Notification && 'granted' !== Notification.permission) {
    Notification.requestPermission()
  }
  return api.put(`notify/sub/${page}`)
}
export function unsub(page) {
  return api.delete(`notify/sub/${page}`)
}
export function subbed(page) {
  return api.get(`notify/sub/${page}`)
}

let active = true
window.addEventListener('blur', e => active = false)
window.addEventListener('focus', e => active = true)

const notifyFilters = []
export function useNotify(history) {
  const notices = useR(new Map<Notification, { user?:string, token?:string }>())
  useE(() => {
    const close = notice => {
      notices.current.delete(notice)
      try { notice.close() } catch {}
    }
    const remove = auth.add(next => {
      for (const [notice, owner] of notices.current) {
        if (next.user !== owner.user || next.token !== owner.token) close(notice)
      }
    })
    return () => { remove(); for (const notice of notices.current.keys()) close(notice) }
  })
  // useE(() => {
  //   if ('default' === Notification?.permission) {
  //     message.trigger({
  //       text: <a onClick={e => Notification.requestPermission()}>Enable notifications for this browser</a>,
  //       id: 'device-notifications',
  //       once: true,
  //     })
  //   }
  // })
  const socket = useSocket({
    on: {
      'notify:msg': async (first, second?) => {
        const packet = decodeNotificationPacket(first, second)
        if (!packet || Notification?.permission !== 'granted' || !socket || !socketRooms(socket).isReady()) return
        const { user, token } = auth.get()
        const owner = { user, token }
        const current = () => socketRooms(socket).isReady() && auth.get().user === owner.user && auth.get().token === owner.token
        try {
          for (const [app, list] of Object.entries(packet.msg)) {
            for (const text of list) {
              if (!current()) return
              if (active && notifyFilters.some(filter => filter(app, text))) continue
              // <text message> - <link> OR <text message> <link>
              const match = text.match(/^(.+)( –)?[\n ]([^\n ]+)$/)
              let body, link
              if (match) {
                [body, link] = [match[1], match[3]]
              } else {
                [body, link] = [text, undefined]
              }
              const displayed = await showDeviceNotification({ app, title: `/${app}`, body, link, tag: link || app })
              if (!current()) return
              if (displayed !== 'unsupported') continue
              const notif = new Notification(`/${app}`, {
                body,
                tag: link || app
              })
              notices.current.set(notif, owner)
              notif.onclose = () => notices.current.delete(notif)
              notif.onclick = () => {
                if (!current()) { notices.current.delete(notif); notif.close(); return }
                let plain = link || `/${app}`
                domains.forEach(x => plain = plain.replace(x.text, ''))
                console.debug('NOTIFICATION CLICK', link, plain)
                url.push(plain)
                // url.push(link?.match('^freshman.dev') ? link.replace('freshman.dev', '') : `/${app}`)
                window.focus()
              }
            }
          }
          if (packet.id && current()) socket.emit(`confirm:${packet.id}`)
        } catch (error) { console.error('Notification display failed', error?.message || String(error)) }
      }
    }
  })
}
// export function useNotify(history) {
//   useInterval(() => {
//     auth.user && api.get('notify/msg').then(
//       ({msg}: {msg: { [key: string]: string[] }}) => {
//       // console.log(msg)
//       Object.entries(msg)
//         .forEach(async entry => {
//           if ('default' === Notification.permission) {
//             await Notification.requestPermission()
//           }
//           let [app, list] = entry
//           list
//           .filter(text => !notifyFilters.some(f => f(app, text)))
//           .forEach(text => {
//             let [body, link] = text.split(' – ')
//             console.log(body, link, history)
//             let notif = new Notification(`/${app}`, {
//               body,
//               tag: link
//             })
//             notif.onclick = () => {
//               history.push(link.replace('freshman.dev', ''))
//             }
//           })
//         })
//     })
//   }, 3000);
// }
export function useNotifyFilter(filter: (app: string, text: string) => boolean) {
  useE(filter, () => {
    notifyFilters.push(filter)
    return () => {
      notifyFilters.splice(notifyFilters.indexOf(filter), 1)
    };
  })
}
